import { createContext, useContext } from "react";

/**
 * 全域殼層能力：Toast、刪除確認、命令面板、使用導覽。
 * 由 layouts/Layout.js 提供，頁面用 useApp() 取用。
 */
export const AppCtx = createContext({
  toast: () => {},
  confirmDelete: () => {},
  openCmd: () => {},
  startTour: () => {},
  setDetailView: () => {},
  isMobile: false,
  userInfo: {},
});

export function useApp() {
  return useContext(AppCtx);
}
